import { IonButton, IonCol,  IonRow, IonText ,IonIcon} from '@ionic/react';
import { printOutline,print, printSharp} from 'ionicons/icons';
const Params = (props) => {
    if(props.params.numfe===101)
    return(
        <IonRow key="params" className="mt2 fondorojo">
            <IonCol key="esc1">
                <IonText>{props.literales.otrostextos.escenario}:</IonText>
            </IonCol>
            <IonCol key="esc2">
                <IonText>{props.literales.otrostextos.fe}: {props.literales.otrostextos.desconocida}</IonText>
            </IonCol>
            <IonCol key="esc3">
                <IonText>{props.literales.otrostextos.tas}: {props.params.numtas}</IonText>
            </IonCol>
        </IonRow>

    );
    else
    return(
        <IonRow key="params" className="mt2 padding20 fondorojo">
            <IonCol key="esc1">
                <IonText className='f2'>{props.literales.otrostextos.escenario}:</IonText>
            </IonCol>
            <IonCol key="esc2">
                <IonText className='f2'>{props.literales.otrostextos.fe}: {props.params.numfe}</IonText>
            </IonCol>
            <IonCol key="esc3">
                <IonText className='f2'>{props.literales.otrostextos.tas}: {props.params.numtas}</IonText>
            </IonCol>
            <IonCol key="esc4">
                <IonText className='f2'>{props.literales.otrostextos.fc}: {props.params.numfc}</IonText>
            </IonCol>
            <IonCol key="esc5">
                <IonText className='f2'>{props.literales.otrostextos.tfg}: {props.params.numtfg}</IonText>
            </IonCol>
            <IonCol key="esc6">
                <IonText className='f2'>{props.literales.otrostextos.k}: {props.params.numk}</IonText>
            </IonCol>
            <IonCol key="esc7" className='noprint'>
                <IonButton size='small' onClick={()=>{window.print(); console.log("print");}} ><IonIcon   icon={printSharp} /></IonButton>
            </IonCol>
        </IonRow>
    );

};

export default Params